<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <!-- <h1 class="m-0 text-primary text-bold">
                            <marquee>ຍິນດີຕ້ອນຮັບລະບົບຈັດການການເງິນ</marquee>
                        </h1> -->
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/dashboard">ໜ້າຫຼັກ</router-link>
              </li>
              <li class="breadcrumb-item active">ແຜນສຳເລັດແລ້ວ</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <section class="content">
      <div class="container-fluid">
        <h1 class="text-center" style="color: #54c392">
          <b>ໜ້າວຽກທີ່ສຳເລັດແລ້ວ</b>
        </h1>
        <br /><br />

        <div class="row">
          <!-- left column -->
          <div class="col-md-1"></div>
          <!--/.col (left) -->
          <!-- right column -->
          <div class="col-md-10" style="overflow: auto">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ໜ້າວຽກປີນີ້</th>
                  <th>ລາຍລະອຽດ</th>
                  <th>ເປີເຊັນ</th>
                  <th>ການເຄື່ອນໄຫວ</th>
                  <th>ສະຖານະ</th>
                  <th>ວັນທີ່ເວລາ</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(yearPlans, year) in groupedPlans" :key="year">
                  <!-- Year Row -->
                  <tr>
                    <td colspan="7" class="text-center bg-light">
                      <b>ໜ້າວຽກປີ {{ year }}</b>
                    </td>
                    <td colspan="1" class="bg-light text-center">
                      <!-- PLUS -->
                      <span
                        v-if="!expandedYears[year]"
                        class="text-bold mx-2"
                        style="cursor: pointer"
                        @click="toggleYear(year)"
                      >
                        <i class="fas fa-plus"></i>
                      </span>

                      <!-- MINUS -->
                      <span
                        v-else
                        class="text-bold mx-2"
                        style="cursor: pointer"
                        @click="toggleYear(year)"
                      >
                        <i class="fas fa-minus"></i>
                      </span>
                    </td>
                  </tr>

                  <!-- Plans of that year -->
                  <tr
                    v-show="expandedYears[year]"
                    v-for="(plan, index) in yearPlans"
                    :key="plan.id"
                  >
                    <td>{{ index + 1 }}</td>

                    <td>
                      <b style="color: #54c392">{{ plan.plan_name }}</b>
                    </td>

                    <td>
                      <b class="text-dark">{{ plan.description }}</b>
                    </td>

                    <td>
                      <b style="color: #54c392">{{ plan.percent }} %</b>
                    </td>

                    <td>
                      <b style="color: #54c392">{{ plan.active }} %</b>
                    </td>

                    <td
                      :class="
                        plan.status === 0 ? 'text-danger' : 'text-success'
                      "
                    >
                      <b>
                        {{
                          plan.status === 0 ? "ຍັງບໍ່ໄດ້ເລີ່ມ" : "ສຳເລັດແລ້ວ"
                        }}
                      </b>
                    </td>

                    <td>
                      <b style="color: #54c392">
                        {{ formatDate(plan.timestamp) }}
                      </b>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!--/.col (right) -->

          <div class="col-md-1"></div>
        </div>

        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "PlanSuccessComponent",
  props: {
    plan: Object,
  },
  watch: {
    groupedPlans: {
      immediate: true,
      handler(val) {
        const years = Object.keys(val);
        if (years.length) {
          this.expandedYears[years[0]] = true;
        }
      },
    },
  },
  computed: {
    groupedPlans() {
      return this.plans.reduce((group, plan) => {
        const year = new Date(plan.timestamp).getFullYear();

        if (!group[year]) {
          group[year] = [];
        }

        group[year].push(plan);
        return group;
      }, {});
    },
    statusClass() {
      return this.plan.status === 0 ? "text-danger" : "text-success";
    },
    statusText() {
      return this.plan.status === 0 ? "not success" : "success";
    },
  },
  data() {
    return {
      plans: [],
      expandedYears: {},
    };
  },
  created() {
    this.fetchPlanSuccess();
  },
  methods: {
    toggleYear(year) {
      this.expandedYears[year] = !this.expandedYears[year];
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
    // for Admin
    async fetchPlanSuccess() {
      try {
        const response = await axios.get(
          "https://nodejs-api-daily-porchoua-4.onrender.com/api/plan_success"
        );
        if (Array.isArray(response.data)) {
          this.plans = response.data;
        } else {
          console.error("Invalid response format:", response.data);
          this.showErrorMessage();
        }
      } catch (error) {
        console.error("Error fetching note:", error);
        this.showErrorMessage();
      }
    },
    // Other methods...
  },
};
</script>
